import { css } from 'styled-components';
import {
  InnerContainer,
  StyledTableCell,
  StyledTableHeaderCell,
} from '../../../../../components/Table/TableCell/styles';
import { colors, themeSpecificColors } from '../../../colors';
import { fonts, fontWeightMedium } from '../../../fonts';

export default css<{ highlight: boolean }>`
  &${StyledTableCell} {
    ${InnerContainer} {
      /* override fonts in InnerContainer (&), and in any component within InnerContainer (& > *) */
      &,
      & > * {
        ${fonts.paragraph};
      }
    }
    /* medium text in first column */
    & :first-child {
      ${InnerContainer} {
        &,
        & > * {
          font-weight: ${fontWeightMedium};
        }
      }
    }

    ${({ highlight }) =>
      highlight &&
      css`
        background-color: ${themeSpecificColors.table_cell_highlight};
      `}
  }

  &${StyledTableHeaderCell} {
    background-color: ${colors.core01};
    text-align: center;

    ${InnerContainer} {
      &,
      & > * {
        color: ${colors.neutral08};
        ${fonts.headingXSmall};
        font-weight: ${fontWeightMedium};
      }
    }
  }
`;
